import { Reducer } from 'redux';
import { update } from '../../helpers/immutabilityHelper'
import * as Dtos from '../../dtos/Fig.dtos';

import {
    ACTION_CLINICALASSESSMENTFORMS_LOAD,
    ACTION_CLINICALASSESSMENTFORMS_LOAD_BY_ID,
    ACTION_CLINICALASSESSMENTFORMS_LOAD_BY_PATIENT_ID,
    ACTION_CLINICALASSESSMENTFORMS_LOAD_BY_PATIENT_IDENTIFIER,
    ACTION_CLINICALASSESSMENTFORMS_LOAD_SUCCESS,
    ACTION_CLINICALASSESSMENTFORMS_LOAD_FAILURE,

    ACTION_CLINICALASSESSMENTFORMS_SAVE,
    ACTION_CLINICALASSESSMENTFORMS_SAVE_SUCCESS,
    ACTION_CLINICALASSESSMENTFORMS_SAVE_FAILURE,

    ACTION_CLINICALASSESSMENTFORMS_CREATE,
    ACTION_CLINICALASSESSMENTFORMS_CREATE_SUCCESS,
    ACTION_CLINICALASSESSMENTFORMS_CREATE_FAILURE,

    ACTION_CLINICALASSESSMENTFORMS_CLEAR,
    ClinicalAssessmentFormAction
} from '../../actions/forms/clinicalAssessmentForm';

import { RequestState } from "../../enumerations/RequestState";
import { IRequestState } from "../index";
import { updateFailureIndexToId } from "../../helpers/formErrorHelper";

export interface IClinicalAssessmentFormState {
    formData: Dtos.ClinicalAssessmentForm | Dtos.ClinicalAssessmentForm[],
    formState: Dtos.RegistrationFormState,
    formProperties: Dtos.RegistrationFormProperty[],
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    saveState: IRequestState;
    createState: IRequestState;
}

const initialState: IClinicalAssessmentFormState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState
};


function loading(state: IClinicalAssessmentFormState, isLoading: boolean): IClinicalAssessmentFormState {
    const newState: IClinicalAssessmentFormState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(state: IClinicalAssessmentFormState,
    formData: Dtos.ClinicalAssessmentForm | Dtos.ClinicalAssessmentForm[],
    formState: Dtos.RegistrationFormState,
    formProperties: Dtos.RegistrationFormProperty[],
    lookups: Dtos.Lookup[], responseStatus: Dtos.ResponseStatus
): IClinicalAssessmentFormState {
    const newState: IClinicalAssessmentFormState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function loadFailure(state: IClinicalAssessmentFormState, responseStatus: Dtos.ResponseStatus): IClinicalAssessmentFormState {
    const newState: IClinicalAssessmentFormState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function saving(state: IClinicalAssessmentFormState, isSaving: boolean): IClinicalAssessmentFormState {
    const newState: IClinicalAssessmentFormState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: IClinicalAssessmentFormState,
    formData: Dtos.ClinicalAssessmentForm | Dtos.ClinicalAssessmentForm[],
    formState: Dtos.RegistrationFormState,
    responseStatus: Dtos.ResponseStatus
): IClinicalAssessmentFormState {
    const newState: IClinicalAssessmentFormState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: IClinicalAssessmentFormState, responseStatus: Dtos.ResponseStatus): IClinicalAssessmentFormState {
    const newState: IClinicalAssessmentFormState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        }
    });

    return newState;
}

function creating(state: IClinicalAssessmentFormState, isCreating: boolean): IClinicalAssessmentFormState {
    const newState: IClinicalAssessmentFormState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: IClinicalAssessmentFormState,
    formData: Dtos.ClinicalAssessmentForm,
    formState: Dtos.RegistrationFormState,
    formProperties: Dtos.RegistrationFormProperty[],
    lookups: Dtos.Lookup[]
): IClinicalAssessmentFormState {
    const newState: IClinicalAssessmentFormState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: IClinicalAssessmentFormState, responseStatus: Dtos.ResponseStatus): IClinicalAssessmentFormState {
    const newState: IClinicalAssessmentFormState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: IClinicalAssessmentFormState): IClinicalAssessmentFormState {
    const newState: IClinicalAssessmentFormState = update(initialState, {});

    return newState;
}

const ClinicalAssessmentFormReducer: Reducer<IClinicalAssessmentFormState> = (state: IClinicalAssessmentFormState = initialState, action: ClinicalAssessmentFormAction) => {
    switch (action.type) {
        case ACTION_CLINICALASSESSMENTFORMS_LOAD:
        case ACTION_CLINICALASSESSMENTFORMS_LOAD_BY_ID:
        case ACTION_CLINICALASSESSMENTFORMS_LOAD_BY_PATIENT_ID:
        case ACTION_CLINICALASSESSMENTFORMS_LOAD_BY_PATIENT_IDENTIFIER:
            return loading(state, true);
        case ACTION_CLINICALASSESSMENTFORMS_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_CLINICALASSESSMENTFORMS_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_CLINICALASSESSMENTFORMS_SAVE:
            return saving(state, true);
        case ACTION_CLINICALASSESSMENTFORMS_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_CLINICALASSESSMENTFORMS_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_CLINICALASSESSMENTFORMS_CREATE:
            return creating(state, true);
        case ACTION_CLINICALASSESSMENTFORMS_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_CLINICALASSESSMENTFORMS_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_CLINICALASSESSMENTFORMS_CLEAR:
            return clear(state);
    }

    return state;
}

export default ClinicalAssessmentFormReducer;